import { render, staticRenderFns } from "./EditOutbreak.vue?vue&type=template&id=628c150c&"
import script from "./EditOutbreak.vue?vue&type=script&lang=js&"
export * from "./EditOutbreak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports